<template lang="pug">
  DataTablePageNew(
    ref="unUsedTable"
    mainColumn=""
    longColumn=""
    title="零用水设备查询"
    label=""
    labelName=""
    :operation="operation"
    :operationWidth=100
    :resource="resource"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :columns="columns")
</template>
<script>
import DataTablePageNew from '@/containers/DataTablePage/defined'
import columns from './waterColumns.js'
import axios from 'axios'
import { expire } from '@/utils/auth'
axios.defaults.withCredentials = true
export default {
  name: 'WaterUnused',
  components: {
    DataTablePageNew
  },
  data () {
    return {
      resource: '/nb/history/zero',
      operation: [{
        label: '查看抄表历史',
        icon: 'meterRecords',
        tooltip: true,
        func ({funcProps}) {
          const { data } = funcProps
          const counterId = data.counterId
          this.$router.push({
            path: `/telnetReading/unusedHistory/${counterId}`
          })
        }
      }],
      tableInitList: ['counterName', 'counterCode', 'hno', 'hname', 'phone', 'mobile', 'addr', 'num', 'time'],
      tableFullList: ['counterName', 'counterCode', 'hno', 'hname', 'phone', 'mobile', 'addr', 'num', 'time'],
      filterInitList: ['copyTime', 'areaId', 'zeroCount'],
      filterFullList: ['copyTime', 'areaId', 'zeroCount'],
      columns: {
        ...columns,
        copyTime: {
          label: '时间',
          type: 'time',
          width: 180,
          size: 8,
          dataType: 'YYYY-MM-DD',
          filter: {
            type: 'daterange'
          },
          form: {
            type: 'date',
            rules: [
              { type: 'number', required: true, message: '请选择开始时间', trigger: 'change' }
            ]
          }
        },
        areaId: {
          label: '计量器区域',
          relation: 'areaId',
          type: 'select',
          width: 150,
          filter: {
            type: 'cascader',
            onlySelectLeaf: false,
            width: 120,
            like: true,
            rules: [{ type: 'required', message: '请选择对应的区域' }]
          },
          form: {
            type: 'cascader',
            onlySelectLeaf: false,
            size: 10,
            rules: [{ type: 'required', message: '请选择对应的区域' }],
            columnSize: [{
              type: 'md',
              size: 6
            }, {
              type: 'sm',
              size: 12
            }]
          }
        },
        counterName: {
          label: '设备名称',
          width: 150
        },
        counterCode: {
          label: '设备编号',
          width: 150
        },
        time: {
          label: '最新抄表时间',
          type: 'time',
          width: 180,
          dataType: 'YYYY-MM-DD'
        },
        num: {
          label: '最新行码',
          width: 100,
          style: {
            textAlign: 'center'
          }
        },
        zeroCount: {
          label: '连续零用水次数',
          width: 80,
          filter: {
            type: 'input',
            width: 100,
            rules: [{ type: 'required', message: '请填写连续零用水次数' },
              { type: 'numeric', message: '输入正确的数字' }
            ],
            suffix: {
              type: 'default',
              text: '次'
            }
          },
          form: {
            type: 'input',
            rules: [
              { type: 'number', required: true, message: '请填写连续零用水次数', trigger: 'change' }
            ]
          }
        }
      }
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    // 加载零用水数据
    this.loadZeroData()
  },
  methods: {
    changeFilterBy (val) {
      this.$refs.unUsedTable.getData()
    },
    loadZeroData () {
      axios.get(this.resource, {
        pageIndex: 1,
        pageSize: 10
      }).then((res) => {
        console.log(res)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// WaterUnused.vue?5288c82f